import React from 'react';

function List(props) {
    return (
        <div>
            list

        </div>
    );
}

export default List;